export default "__VITE_ASSET__CwulxcZl__"